import { create } from 'zustand'

export type PopoverTrackedState = {
  popoverIdOpened: string | number | null
  setPopoverIdOpened: (id: string | number | null) => void
  nonExclusiveAreas: Set<string>
  addNonExclusiveArea: (area: string) => void
  removeNonExclusiveArea: (area: string) => void
}

const usePopoverTrackedStore = create<PopoverTrackedState>((set) => ({
  popoverIdOpened: null,
  nonExclusiveAreas: new Set(['bookings-list', 'inquiries-list', 'schedule']),

  setPopoverIdOpened: (id) => {
    set({ popoverIdOpened: id })
  },

  addNonExclusiveArea: (area) => {
    set((state) => ({
      nonExclusiveAreas: new Set([...state.nonExclusiveAreas, area]),
    }))
  },

  removeNonExclusiveArea: (area) => {
    set((state) => {
      const newAreas = new Set(state.nonExclusiveAreas)
      newAreas.delete(area)
      return { nonExclusiveAreas: newAreas }
    })
  },
}))

function getCurrentArea(): string | null {
  if (typeof window === 'undefined') return null

  const path = window.location.pathname

  if (path === '/bookings' || path === '/bookings/') return 'bookings-list'
  if (path === '/inquiries' || path === '/inquiries/') return 'inquiries-list'
  if (path.includes('/schedule')) return 'schedule'

  return null
}

export const usePopoverTrackedState = () => {
  const store = usePopoverTrackedStore()

  return {
    popoverIdOpened: store.popoverIdOpened,
    setPopoverIdOpened: store.setPopoverIdOpened,
    isNonExclusive: () => {
      const currentArea = getCurrentArea()
      return currentArea ? store.nonExclusiveAreas.has(currentArea) : false
    },
  }
}
